module.exports = __webpack_public_path__ + "static/media/tabasco.50a4f669.png";